export const dtoReg = (data: any) => {
  const email = localStorage.getItem("temporaryemail") || "";

  const dataDto: any = {
    email: email.toLowerCase().trim(),
    code: data.code,
    name: data.name,
    date_birthday: data.date,
    password: data.password.trim(),
    personnel_number: data.prNumber,
    city: data.city,
  };

  const referralMarker = sessionStorage.getItem("referral_marker");
  if (referralMarker) {
    dataDto.referral_marker = referralMarker;
  }

  return dataDto;
};

export const dtoRegEmail = (data: any) => {
  const dataDto: any = {
    email: data.email.toLowerCase().trim(),
  };

  return dataDto;
};
